import { PrescriptionRepository } from "@/domain/repository/prescription-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class CreatePrescriptionUsecase {
  constructor(private readonly prescriptionRepo: PrescriptionRepository) {}

  async execute(payload: Record<string, unknown>): Promise<SATResult<void, SATError>> {
    return this.prescriptionRepo.createPrescription(payload);
  }
}
